<template>
  <page-wrapper
    v-if="$can('GetList', 'ScheduleLoyaltyDiscountUserAbsences')"
    :isLoading="isLoading"
    :hasFilters="true"
    @submitFilters="getUserAbsence"
  >
    <template #title> جزئیات وفاداری </template>
    <template #filters>
      <range-date-picker
        label="بازه تاریخ وفاداری"
        @getDateRange="setDateRange"
      ></range-date-picker>
    </template>
    <custom-table
      :pageNumber="absenceFilters.pageNumber"
      :count="absenceFilters.count"
      :totalCount="totalCount"
      :tableColumns="myTableColumns"
      :tableItems="absenceList"
      @changePage="changePage"
    >
      <template #startDate="data">
        {{ new Date(data.item.startDate).toLocaleDateString("fa-IR") }}
      </template>
      <template #endDate="data">
        {{ new Date(data.item.endDate).toLocaleDateString("fa-IR") }}
      </template>
      <template #scheduleLoyaltyDiscountUserAbsencesGridResultDays="data">
        <template
          v-if="
            data.item.scheduleLoyaltyDiscountUserAbsencesGridResultDays
              .length == 0
          "
        >
          -
        </template>
        <template v-else>
          <p
            v-for="item in data.item
              .scheduleLoyaltyDiscountUserAbsencesGridResultDays"
          >
            تاریخ:‌
            {{ new Date(item.dayOfWeek).toLocaleDateString("fa-IR") }}
            -
            {{ item.minute }} دقیقه
          </p>
        </template>
      </template>
    </custom-table>
  </page-wrapper>
</template>

<script>
export default {
  mounted() {
    this.getUserAbsence();
  },
  watch: {
    userIdFilter: {
      immediate: true,
      handler(val) {
        if (val) {
          this.absenceFilters.userId = val;
        } else {
          this.absenceFilters.userId = null;
        }
      },
    },
  },
  props: {
    userIdFilter: {
      type: [String, Number],
      required: false,
    },
  },
  data() {
    return {
      isLoading: false,
      absenceList: null,
      totalCount: null,
      dateRange: null,
      absenceFilters: {
        pageNumber: 1,
        count: 10,
        startDate: null,
        endDate: null,
        userId: null,
        priceCategroyId: null,
        priceCategroyTitle: null,
        reserveDayPerEachWeek: null,
        reserveDayPerEachWeekMin: 0,
        dayOfWeekMin: null,
        dayOfWeek: null,
        userFullname: null,
        userMobile: null,
      },

      myTableColumns: [
        {
          key: "priceCategroyTitle",
          label: "گروه‌بندی",
        },
        {
          key: "startDate",
          label: "از تاریخ",
        },
        {
          key: "endDate",
          label: "تا تاریخ",
        },
        {
          key: "scheduleLoyaltyDiscountUserAbsencesGridResultDays",
          label: "رزرو شده",
        },
      ],
    };
  },
  methods: {
    changePage(pageNumber) {
      this.absenceFilters.pageNumber = pageNumber;
      this.getUserAbsence();
    },
    setDateRange(dateRange) {
      if (dateRange) {
        this.dateRange = dateRange;
      } else {
        this.clearDateRange();
      }
    },
    setPageNumberAndSendRequest() {
      this.absenceFilters.pageNumber = 1;
      this.getUserAbsence();
    },
    clearDateRange() {
      this.dateRange = null;
      this.absenceFilters.startDate = null;
      this.absenceFilters.endDate = null;
    },
    calculateDates() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.absenceFilters.startDate = new Date(this.dateRange?.[0]);
        this.absenceFilters.endDate = new Date(this.dateRange?.[1]);
      }
    },
    async getUserAbsence() {
      this.calculateDates();
      try {
        this.isLoading = true;
        let _this = this;
        let getListForLoyaltyDetails = new GetListForLoyaltyDetails(_this);
        getListForLoyaltyDetails.setRequestParamDataObj(_this.absenceFilters);
        await getListForLoyaltyDetails.fetch((res) => {
          _this.absenceList = res.data;
          _this.totalCount = res.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    RangeDatePicker,
    PageWrapper,
    CustomTable,
  },
};
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { GetListForLoyaltyDetails } from "@/libs/Api/ScheduleLoyaltyDiscountUserAbsences";
</script>
